module.exports = __webpack_public_path__ + "img/icon-cup-1.3c90de63.svg";